<template>
  <div class="row">
    <div class="col-lg-12">
      <h5 class="text-primary">{{ reportType.title + ' Filtreleme Alanları' }}</h5>
    </div>
    <div class="col-lg-3">
      <v-select
          v-model="salesPersonCode"
          label="Plasiyer"
          filled
          solo
          dense
          :items="salesPersonList"
          :item-text="item => item.name"
          :item-value="item => item.code"
          clearable
      >

      </v-select>
    </div>
    <div class="col-lg-3">
      <v-menu
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="auto"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
              :value="formattedDate(dateRangeStart)"
              label="Tarih Aralık Başlangıç"
              prepend-inner-icon="mdi-calendar"
              readonly
              filled
              solo
              dense
              clearable
              @click:clear="dateRangeStart = null"
              v-bind="attrs"
              v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker
            v-model="dateRangeStart"
            locale="tr"
        ></v-date-picker>
      </v-menu>
    </div>
    <div class="col-lg-3">
      <v-menu
          transition="scale-transition"
          :close-on-content-click="false"
          offset-y
          min-width="auto"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
              :value="formattedDate(dateRangeEnd)"
              label="Tarih Aralık Bitiş"
              prepend-inner-icon="mdi-calendar"
              readonly
              filled
              solo
              dense
              clearable
              @click:clear="dateRangeStart = null"
              v-bind="attrs"
              v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker
            v-model="dateRangeEnd"
            locale="tr"
        ></v-date-picker>
      </v-menu>
    </div>
    <div class="col-lg-12 text-end">
      <v-btn small color="primary" @click="filterReport"><v-icon left>mdi-filter</v-icon>FİLTRELE</v-btn>
    </div>
  </div>
</template>

<script>

import {formattedDate} from "@/momentHelper";
import {mapActions, mapState} from "vuex";

export default {
  name: "HedefPotansiyelPlasiyer",
  props:{
    reportType:{
      type: Object,
      default: () => {}
    }
  },
  mounted(){
    this.fetchSalesPersonList({
      params:{},
      body:{}
    });
    this.filterReport()
  },
  computed:{
    ...mapState("current",["salesPersonList"]),
  },
  data(){
    return {
      dateRangeStart: null,
      dateRangeEnd: null,
      salesPersonCode: null
    }
  },
  methods:{
    formattedDate,
    ...mapActions("current", ["fetchSalesPersonList"]),
    filterReport(){
      /*this.$v.$touch();*/
      this.filterRequestObject = {
        StartDate: this.dateRangeStart,
        FinishDate: this.dateRangeEnd,
        SalesPersonCode: this.salesPersonCode,
      };
      this.$emit("reportFilterChange",this.filterRequestObject);
      /*if(!this.$v.$invalid){

      }
      else
        showProcessErrorMessage({
          title: 'Filtreleme Başarısız',
          text: 'Lütfen gerekli alanları doldurun'
        })*/

    }
  }
}
</script>

<style scoped>

</style>